/**
 * Toggle visibility of contact popups
 * 
 * @author Rianne Oosthoek <rianne@click.nl>
 */
window.contact_popup = function() {
    var self = this;
    var $contact_popup_buttons          = $('.js-contact-popup-button');
    var $contact_popup_windows          = $('.js-contact-popup-window');
    var $webchat_popup_window           = $('.js-webchat-popup-window');
    var $contact_popup_close_buttons    = $('.js-contact-popup-close-button');
    var $webchat_form                   = $('.js-webchat-form');
    var $errors                         = $('.js-error');
    var $body                           = $('body');
    var $window                         = $(window);
    var is_browser_safari               = false;

    self.init = function( browser ) {
        var current_window_width = getWindowWidth();

        // Create click listener on contact icons
        $contact_popup_buttons.on('click', self.toggleVisibilityContactPopup);
        // Create click listener on close button
        $contact_popup_close_buttons.on('click', self.closeContactPopup);

        // Only execute when webchat window is present in DOM
        if($webchat_popup_window.length > 0) {
            // Create resize listener to freeze/unfreeze body for webchat popup
            $window.on('resize', function() {
                // First set new window width
                var new_window_width = getWindowWidth();
                // Only execute code when width of window is changed
                if( new_window_width !== current_window_width ) {
                    // Popup is opened 
                    // Body has 'disabled' class 
                    // Window width is greater than or equal to 640px
                    if( !$webchat_popup_window.hasClass('hide') 
                        && $body.hasClass('u-disable-scroll')
                        && (new_window_width >= getBreakpointSize('medium')) 
                    ) {
                        self.unfreezeBody();
                    // Popup is opened
                    // Body doesn't have 'disabled' class
                    // Window width is smaller than 640px
                    } else if( 
                        !$webchat_popup_window.hasClass('hide')
                        && !$body.hasClass('u-disable-scroll')
                        && (new_window_width < getBreakpointSize('medium')) 
                    ) {
                        self.freezeBody();
                    }
                    // Set new current width
                    current_window_width = new_window_width;
                }
            });


            // If browser is safari, set var
            if( browser === 'Safari' ){
                is_browser_safari = true;
            }

            // Create listnener for submitting the webchat form
            $webchat_form.on('submit', self.submitForm);
        }
    };

    /**
     * Toggle visibility of contact popups
     *
     * @author Rianne Oosthoek <rianne@click.nl>
     * @return  void
     */
    self.toggleVisibilityContactPopup = function() {
        // Create variable from data-type value from clicked contact icon
        var contact_popup_type = $(this).attr('data-contact-popup-type');
        var $contact_popup_window = $contact_popup_windows.filter('[data-contact-popup-type="' + contact_popup_type + '"]');
        // Toggle hide class on corresponding contact popup and close any other contact popup
        if( $contact_popup_window.hasClass('hide') ) {
            var current_window_width = getWindowWidth();

            // Close other popups
            $contact_popup_windows.addClass('hide');
            // Open clicked popup
            $contact_popup_window.removeClass('hide');

            // Check if breakpoint size is smaller than medium
            if( current_window_width < getBreakpointSize('medium') ) {
                // If so, freeze the body
                self.freezeBody();
            } else {
                // If not, do nothing
            }

        } else {
            // Close popup
            $contact_popup_window.addClass('hide');
            // Unfreeze body
            self.unfreezeBody();
        }
    };

    /**
     * Close contact popups
     *
     * @author Rianne Oosthoek <rianne@click.nl>
     * @return  void
     */
    self.closeContactPopup = function() {
        $contact_popup_windows.addClass('hide');
        // Unfreeze body
        if( $body.hasClass('u-disable-scroll') ) {
            self.unfreezeBody();
        }
    };

    /**
     * Freeze body on opening popup depending on current breakpoint size of window
     *
     * @author Rianne Oosthoek <rianne@click.nl>
     * @return  void
     */
    self.freezeBody = function() {
        $body.addClass('u-disable-scroll');
    };

    /**
     * Unfreeze body
     *
     * @author Rianne Oosthoek <rianne@click.nl>
     * @return  void
     */
    self.unfreezeBody = function() {
        $body.removeClass('u-disable-scroll');
    };

    /**
     * Method for when the form has been submitted
     *
     * @author Dennis Bruinen <dennis@click.nl>
     * @param  Event e
     * @return void
     */
    self.submitForm = function(e) {
        e.preventDefault();
        $contact_popup_error = $(this).parents().find('.js-contact-popup-error');

        // Get the form data
        var form_data = new FormData( $(this)[0] );

        // Do an asynchronous call to check the filled in form data
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: form_data,
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            success: self.formOnSuccess,
            error: self.formOnError
        });
    };

    /**
    * When the form has been submitted succesfully
    *
    * @author Dennis Bruinen <dennis@click.nl>
    * @param  Response data
    * @return void
    */
    self.formOnSuccess = function(data) {
        // Reset error fields
        $errors.html('');
        $contact_popup_error.empty();

        // Determine webchat url
        var webchat_url = 'https://www.timeforstorm.eu/IM/endpoint/guest/124/Vraag%20Loogman/0e92b51a77c224e11df1222b9a95dc84764b45330d59e3958b69e7b3425d72f0';
        webchat_url = webchat_url + '?name='+data.data.name+'&subject='+data.data.subject+'&email='+data.data.email;
        // Send user to webchat, if user is in Safari, open url in same tab (Safari doesn't play nice with new generated tabs)
        if( is_browser_safari ){
            window.location.assign(webchat_url);
        }else{
            window.open(webchat_url, '_blank');
        }
    };

    /**
    * When the form has an error, show the error below each field
    *
    * @author Dennis Bruinen <dennis@click.nl>
    * @param  Response error
    * @return void
    */
    self.formOnError = function(error) {
        // Reset error fields
        $errors.html('');
        $contact_popup_error.empty();
        // Iterate through errors
        var errors = [];
        if(error.responseJSON) {
            errors = error.responseJSON.errors;
        }
        // Iterate through every error
        for(let error in errors) {
            // Iterate through every array element in error
            for(var i = 0; i < errors[error].length; i++) {
                // find generic contact error div
                if(error == 'contact_popup_error'){
                    $contact_popup_error.html(errors[error][i]);
                }
                // Show the errors
                $webchat_form.find('[name="'+error+'"]').parent().find('.js-error').text(errors[error][i]);
            }
        }
    };
};


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/contact-popup.js